module.exports = __webpack_public_path__ + "img/HealthChat.28f0ce6b.svg";